// extracted by mini-css-extract-plugin
module.exports = {"shared-activity-message":"shared-activity-message___3d6yB"};